export const areEthAddressesEqual = (
  firstAddress?: string,
  secondAddress?: string,
) => {
  return (
    firstAddress &&
    secondAddress &&
    firstAddress?.toLowerCase() === secondAddress?.toLowerCase()
  );
};
